import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EJRecordTypes } from 'src/common/enumerations/ej-record-types';
import { getPrice, getItemName } from 'src/common/helpers/action-window-helper';
import { IElectronicJournalRecord } from 'src/common/interfaces/states/IElectronicJournalRecord';
import { ReactComponent as CouponIcon } from 'src/common/media/Coupon.svg';
import { ReactComponent as CouponGreenIcon } from 'src/common/media/CouponGreenIcon.svg';
import { ReactComponent as CouponVoidedIcon } from 'src/common/media/CouponVoided.svg';
import { ReactComponent as PromotionIcon } from 'src/common/media/Promotions.svg';
import { ReactComponent as TenderIcon } from 'src/common/media/RewardAsTender.svg';
import { styles } from './action-window-styles';

const ActionWindowHead: React.FC<Props> = ({
  selectedItem,
  isKeypadVisible,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const classes = styles({});
  const isCouponOrReward =
    selectedItem.Type === EJRecordTypes.Coupon ||
    selectedItem.Type === EJRecordTypes.Promotion ||
    selectedItem.Type === EJRecordTypes.RewardAsTender;

  const ActionWindowCouponIcon = (): JSX.Element => {
    if (selectedItem.Voided) {
      return (
        <CouponVoidedIcon
          data-testid='action-window-head-coupon-voided-icon'
          className={classes.icon}
        />
      );
    }
    if (selectedItem.CouponRedemptionState?.Redeemed) {
      return (
        <CouponGreenIcon className={classes.icon} data-testid='action-window-coupon-enabled' />
      );
    } else {
      return <CouponIcon className={classes.icon} data-testid='action-window-coupon-disabled' />;
    }
  };

  const iconObjects = {
    [EJRecordTypes.Promotion]: (
      <PromotionIcon
        data-testid='action-window-head-promotion-icon'
        className={`${classes.icon} ${classes.iconMinWidth}`}
      />
    ),
    [EJRecordTypes.RewardAsTender]: (
      <TenderIcon data-testid='action-window-head-tender-icon' className={classes.icon} />
    ),
    [EJRecordTypes.Coupon]: <ActionWindowCouponIcon data-testid='action-window-head-coupon-icon' />,
  };

  const getItemIcon = (): JSX.Element => (isCouponOrReward ? iconObjects[selectedItem.Type] : null);
  const itemName = getItemName(selectedItem, t);

  return (
    <>
      <Grid
        item
        xs={isKeypadVisible ? 8 : 9}
        className={`${classes.item} ${isKeypadVisible ? classes.smallText : ''}`}
        data-testid='action-window-item-name'
      >
        {getItemIcon()}
        <span
          data-testid='action-window-head-get-item-name'
          className={`${classes.actionWindowText} ${isCouponOrReward ? classes.superText : ''}`}
        >
          {itemName}
        </span>
      </Grid>

      <Grid
        item
        xs={isKeypadVisible ? 4 : 3}
        className={`${classes.textAlignRight} ${classes.itemPrice}`}
        data-testid='action-window-item-price'
      >
        {`${selectedItem.Type === EJRecordTypes.RewardAsTender ? '-' : ''}`}
        {getPrice(selectedItem.Type === EJRecordTypes.Coupon, selectedItem)}
      </Grid>
    </>
  );
};

interface Props {
  isKeypadVisible: boolean;
  selectedItem: IElectronicJournalRecord;
}

export default ActionWindowHead;
